import React from 'react';
import PropTypes from 'prop-types';

import uniqBy from 'utils/uniqBy';
import { formatPrice } from 'utils/format';

import { getTransformedPage } from 'editor-utils/template';
import Page from '../../components/page/preview';
import DesignSelect from './designSelect';
import DropDownPanel from './dropDownPanel';

// Utility function for template caption split
const formatCaption = caption => caption.split(' - ').map(split => split.toUpperCase());

const MultiProductDesignSelect = props => {
  const activePageId = props.item.pages[0].id;
  const activeProductId = props.product.id;

  const pagePrefix = activePageId.substr(0, activePageId.lastIndexOf('-'));

  const designs = uniqBy(
    props.items
      .filter(item => item.pageId.indexOf(pagePrefix) === 0)
      .map(item => ({ design: item.group.toLowerCase(), pageId: item.pageId })),
    'design',
  );

  const activeDesign = props.items.find(item => item.pageId === activePageId)?.group.toLowerCase();

  const layouts = props.items.filter(item => item.group.toLowerCase() === activeDesign);

  const handleOnChangeLayout = pageId => {
    const { sku } = props.items.find(item => item.pageId === pageId);

    props.onChange(sku, pageId);
  };

  const handleOnChangeDesign = pageId => {
    const { sku } = props.items.find(item => item.pageId === pageId);

    props.onChange(sku, pageId);
  };

  return (
    <>
      {layouts.length > 0 && (
        <DropDownPanel
          key="initial_page_toolbar"
          title="SELECT TREE TYPE"
          active={activePageId}
          items={layouts.map(p => {
            // TODO is formatCaption really needed?
            return {
              value: p.pageId,
              title: p.templateName,
              subtitle: p.caption,
              description: formatPrice(p.price, p.currency),
            };
          })}
          onChange={handleOnChangeLayout}
          className="mb-3"
        />
      )}

      {designs.length > 0 && (
        <DesignSelect
          key="change_page_toolbar"
          title="PICK A DESIGN"
          active={activePageId}
          onChange={handleOnChangeDesign}
          items={designs.map(design => ({
            key: design.pageId,
            preview: (
              <Page
                page={getTransformedPage(props.template, props.item.pages[0], design.pageId)}
                template={props.template}
                photos={props.item.photos}
                preview
              />
            ),
          }))}
          className="mb-3"
        />
      )}
    </>
  );
};

MultiProductDesignSelect.propTypes = {
  item: PropTypes.object,
  product: PropTypes.object,
  template: PropTypes.object,
  items: PropTypes.array,
  onChange: PropTypes.func,
};

export default MultiProductDesignSelect;
